



















































import { Carousel, Slide } from '@fc/angie-ui';
import { defineComponent } from '@vue/composition-api';
import { useModal } from '~/composables/useModal';
import FCImage from '~/components/FCImage.vue';

const videoData = [
  {
    firstFrameImage: {
      filename: 'https://a.storyblok.com/f/152150/870x489/27a9fdfa7f/fc-trainer-jess-resistance-band-workout-play-001.jpg',
      alt: 'Fightcamp trainer Jess working out with resistance bands in a FightCamp workout.',
    },
    mobileVideoPlayback: 'auto',
    mp4MobileVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-jess-resistance-band-002.mp4',
    mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-jess-resistance-band-002.mp4',
    tabletUpVideoPlayback: 'auto',
    webmMobileVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-jess-resistance-band-001.webm',
    webmVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-jess-resistance-band-001.webm',
  },
  {
    firstFrameImage: {
      filename: 'https://a.storyblok.com/f/152150/870x489/4046a994bc/fc-trainer-pj-resistance-band-workout-play-001.jpg',
      alt: 'Fightcamp trainer PJ working out with resistance bands in a FightCamp workout.',
    },
    mobileVideoPlayback: 'auto',
    mp4MobileVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-pj-resistance-band-002.mp4',
    mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-pj-resistance-band-002.mp4',
    tabletUpVideoPlayback: 'auto',
    webmMobileVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-pj-resistance-band-001.webm',
    webmVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-pj-resistance-band-001.webm',
  },
  {
    firstFrameImage: {
      filename: 'https://a.storyblok.com/f/152150/870x489/ee63dde1bf/fc-trainer-flo-resistance-band-workout-play-001.jpg',
      alt: 'Fightcamp trainer Flo working out with resistance bands in a FightCamp workout.',
    },
    mobileVideoPlayback: 'auto',
    mp4MobileVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-flo-resistance-band-002.mp4',
    mp4VideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-flo-resistance-band-002.mp4',
    tabletUpVideoPlayback: 'auto',
    webmMobileVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-flo-resistance-band-001.webm',
    webmVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/fc-flo-resistance-band-001.webm',
  },
];

export default defineComponent({
  name: 'AccessoryVideoHighlight',
  components: {
    Carousel,
    Slide,
    FCImage,
  },
  setup(_, context) {
    function openModal(image: any) {
      const width = Math.min(680, Math.floor(window.innerWidth * 0.85));

      const { modalShow } = useModal({
        component: () => import('~/components/storyblok/VideoModal/VideoModal.vue'),
        componentProps: {
          firstFrameImage: image.firstFrameImage,
          mobileVideoPlayback: 'auto',
          mp4VideoUrl: image.mp4VideoUrl,
          tabletUpVideoPlayback: 'auto',
          webmVideoUrl: image.webmVideoUrl,
        },
        modalProps: {
          componentName: 'VideoModal',
          width,
          height: Math.floor(width / (16 / 9)),
          reset: true,
          classes: 'modal-border-radius',
        },
        options: {
          emit: context.emit,
          openEvent: {
            name: 'onPause',
            payload: true,
          },
          closeEvent: {
            name: 'onPause',
            payload: false,
          },
        },
      });

      modalShow();
    }

    return { openModal, videoData };
  },
});
